import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbToastModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { WidgetModule } from './widget/widget.module';

import { PagetitleComponent } from './pagetitle/pagetitle.component';
import { ToastsContainer } from './toast/toast.component';
import { SpinnerComponent } from './spinner/spinner.component';
import DropdownSelectComponent from './dropdown-select/dropdown-select.component';
import { NameFormatPipe } from './pipes/NameFormatPipe';
import { HasRoleDirective } from './directive/has-role/has-role.directive';
import { TruncatePipe } from './pipes/truncate.pipe';
import { CollaboratorButtonComponent } from './button/collaborator/collaborator-button.component';

@NgModule({
  declarations: [
    PagetitleComponent,
    SpinnerComponent,
    DropdownSelectComponent,
    NameFormatPipe,
    HasRoleDirective,
    TruncatePipe,
    CollaboratorButtonComponent,
  ],
  imports: [NgbToastModule, CommonModule, WidgetModule, ToastsContainer, TranslateModule],
  exports: [
    ToastsContainer,
    PagetitleComponent,
    SpinnerComponent,
    DropdownSelectComponent,
    NameFormatPipe,
    HasRoleDirective,
    TruncatePipe,
    CollaboratorButtonComponent,
  ],
})
export class SharedModule {}
